import { render } from "./GlobalTooltip.vue?vue&type=template&id=57befb5a"
import script from "./GlobalTooltip.vue?vue&type=script&lang=js"
export * from "./GlobalTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__